import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_FAQ = createActionTypes('FETCH_FAQ');
export const GET_FAQ = createActionTypes('GET_FAQ');
export const CREATE_FAQ = createActionTypes('CREATE_FAQ');
export const UPDATE_FAQ = createActionTypes('UPDATE_FAQ');
export const DELETE_FAQ = createActionTypes('DELETE_FAQ');
